import type { KpisConfigProvider } from './interfaces/kpis-config.provider'
import { FeatureIdEnum, KpiEnum } from '../enums'

export function getKpisConfigProvider(): KpisConfigProvider {
  return () => {
    return {
      orderOfKpis: [
        KpiEnum.QUERIES,
        KpiEnum.CLICKS,
        KpiEnum.FINDABILITY,
        KpiEnum.ADD2CART,
        KpiEnum.CHECKOUT,
        KpiEnum.NO_RESULTS,
      ],
      findabilityEngagementKpi: KpiEnum.CLICKS,
      tools: {
        [FeatureIdEnum.NOW]: [KpiEnum.QUERIES, KpiEnum.CLICKS, KpiEnum.NO_RESULTS],
      },
    }
  }
}
